module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.7970be9a.woff";